(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxFavouritesItemsPanel', {
		bindings: {},
		controller: MxFavouritesItemsPanelCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-left-side-panel/mx-favourites-items-panel/mx-favourites-items-panel.html',
	});

	MxFavouritesItemsPanelCtrl.$inject = ['mx.shell.SidePanelService', 'mx.SolutionBuilderAgent.FavouritesService', 'mx.shell.NavigationService'];

	function MxFavouritesItemsPanelCtrl(sidePanelService, favouritesService, navigationService) {
		var vm = this;
		vm.sidePanelService = sidePanelService;
		vm.favouritesService = favouritesService;
		vm.navigationService = navigationService;

		vm.setFavoritesFilter = function (filterText) {
			vm.viewsFilter = filterText;

			vm.favouritesService.filterNavigations(filterText);
		};

		return vm;
	}
})();
